import type { ServiceRequest, ServiceRequestMessage } from "bonusx-api-main-manager";

export enum MessageSender {
  Citizen = "Citizen",
  Operator = "Operator",
}

export function tryGetBelongingUnreadMessages(
  messageSender: MessageSender,
  serviceRequest?: ServiceRequest,
  messages?: ServiceRequestMessage[] | undefined
): ServiceRequestMessage[] {
  const requestAccountId = serviceRequest?.citizen?.accountId;
  if (!requestAccountId || !messages) {
    return [];
  }

  const unreadMessages = messages?.filter((message) => !message.seen);

  const filterPredicate =
    messageSender === MessageSender.Citizen
      ? (message: ServiceRequestMessage) => message.senderId !== requestAccountId
      : (message: ServiceRequestMessage) => message.senderId === requestAccountId;

  const filteredMessages = unreadMessages?.filter(filterPredicate);

  return filteredMessages ?? [];
}
